const STYLIST_COLUMN = 'stylist_column';

const DND = Object.freeze({
  // drag
  dragCategory: 'settings-category-drag',
  dragEvent: 'event',
  dragPlaceholder: 'placeholder',
  dragService: 'settings-service-drag',
  dragStylistColumn: STYLIST_COLUMN,

  // drop
  dropCategory: 'settings-category-drop',
  dropCell: 'cell',
  dragProcedure: 'procedure',
  dropService: 'settings-service-drop',
  dropStylistColumn: STYLIST_COLUMN,

  // resize
  resizeEvent: 'event_resize_handle',
  resizeProcedure: 'procedure_resize_handle',
});

export default DND;
